import { render, staticRenderFns } from "./tab-content.vue?vue&type=template&id=41173a7d&scoped=true"
import script from "./tab-content.vue?vue&type=script&lang=js"
export * from "./tab-content.vue?vue&type=script&lang=js"
import style0 from "./tab-content.vue?vue&type=style&index=0&id=41173a7d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41173a7d",
  null
  
)

export default component.exports